var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgEmeraldGemOutline = function SvgEmeraldGemOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 728 728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M532 96.75L255.5 66.25L169 148.25L124 535.75L192.5 633.75L403.5 656.25L470 661.75L558 587.75L604 190.75L532 96.75Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgEmeraldGemOutline);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/status/emerald-gem-outline.723e05087f20f29405ba02b3705d5fd3.svg";